import { numberFormatter } from '@hh.ru/front-static-app';

import { ProfessionAreaChartDirection as Direction, ProfessionAreaChartItem } from 'src/models/pages/profession';

import {
    ERROR_COLOR,
    ERROR_GRADIENT_ID,
    SUCCESS_COLOR,
    SUCCESS_GRADIENT_ID,
} from 'src/pages/Profession/components/SectionStatistics/AreaChart/Chart/constants';

export const numberTickFormatter = (value: ProfessionAreaChartItem['year']): string =>
    numberFormatter.format(value.toString());

const checkIsMoreCharItem = (chartItem: ProfessionAreaChartItem): boolean =>
    chartItem.diff.direction !== Direction.LESS;
export const getChartItemColor = (chartItem: ProfessionAreaChartItem): string =>
    checkIsMoreCharItem(chartItem) ? SUCCESS_COLOR : ERROR_COLOR;

export const getAreaBgColor = (chartItem: ProfessionAreaChartItem): string =>
    checkIsMoreCharItem(chartItem) ? `url(#${SUCCESS_GRADIENT_ID})` : `url(#${ERROR_GRADIENT_ID})`;
